export default "__VITE_ASSET__73d49e27__"